import { createFileRoute } from "@tanstack/react-router";
import { buildHead } from "@/lib/seo-head";
import Briefing from "@/pages/Briefing";

export const Route = createFileRoute("/briefing")({
  head: () => buildHead({
    title: "Briefing de Agentes de IA | OP2P",
    description: "Preencha o briefing OP2P para criação do seu Agente de IA: escopo, base de conhecimento, tom de voz, qualificação e regras de atendimento.",
    path: "/briefing",
  }),
  component: Briefing,
});
